import * as _ from 'underscore';
import { SiteRoleOptionsResource } from '../../userManagement/services/resources/SiteRoleOptions';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { ISelectFilterDefinitionOption } from '../services/FilterPanelService';

export module SiteRoleFilterHelper {

  export let AnyRole = 'Any';

  export function siteRoleOptions(roles: string[],userCountsByRole?: _.Dictionary<number>) {

    if (!userCountsByRole) {
      userCountsByRole = {};
    }

    const options: ISelectFilterDefinitionOption<string>[] = [
      {
        value: AnyRole,
        translate: 'siteRole_Any',
        count: userCountsByRole[AnyRole]
      }
    ];

    _.each(roles, (role: string) => {
      if ((role !== SiteRoles.SupportUser) || userCountsByRole[role] > 0) {
        options.push({
          value: role,
          translate: SiteRoleOptionsResource.instance.getSiteRoleLockey(role),
          count: userCountsByRole[role]
        });
      }
    });

    return options;
  }

}
